// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rounder-section{background-color:red;height:20px}.rounder-section .rounder-section-space{height:20px}.rounder-section .rounder-section-content{background-color:#eee;border-top-left-radius:20px;border-top-right-radius:20px;height:20px;position:relative;top:-20px}@media(prefers-color-scheme:dark){.rounder-section .rounder-section-content{background-color:#222}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
